import React from 'react';
import PageAuthorize from '../../../../security/PageAuthorize';
import ListContainer from '../../../../presentation/ListContainer';
import layout from './layout.json';

class ProgramsList extends React.Component {
  constructor( props ) {
    super( props );

    this.state = {
      row: {},
      currentProgramTab: 0,
      showProgramsDialog: false
    }

    this.onIconClicked = this.onIconClicked.bind( this );
    this.onClose = this.onClose.bind( this );
  }

  onIconClicked( args ) {
    let currentProgramTab = this.state.currentProgramTab;

    // Group Icon was clicked, go directly to the Group Settings tab
    if ( args.cellIndex === 1 ) {
      currentProgramTab = 5;
    }

    this.setState( {
      row: args.row,
      currentProgramTab: currentProgramTab,
      showProgramsDialog: true
    } );
  }

  onClose( e ) {
    this.setState( {
      showProgramsDialog: false,
      currentProgramTab: 0
    } );
  }

  render() {
    return (
      <PageAuthorize groups={['Administrators', 'Operations', 'Management']}>
        <ListContainer
          id="ProgramsList"
          layout={layout}
          selectedtab={1}
          row={this.state.row}
          showProgramsDialog={this.state.showProgramsDialog}
          currentProgramTab={this.state.currentProgramTab}
          onIconClicked={this.onIconClicked}
          onProgramsDialogClose={this.onClose}
        />
      </PageAuthorize>
    );
  }
}

export default ProgramsList;



// WEBPACK FOOTER //
// ./src/content/enterprise/programs/components/ProgramsList.js